import useAuth from "../../hooks/useAuth";
import { Navigate } from 'react-router-dom';

export default function IsAuth({children}: any){
    const auth = useAuth();

    // ADICIONE ESTA TRAVA:
    if (auth.loading) {
        return null; // A tela fica "congelada" na dashboard original até o login confirmar
    }

    if(!auth.user){
        return <Navigate to='/'/>
    } else {
        return children
    }
}